import { render, staticRenderFns } from "./UserBlacklistList.vue?vue&type=template&id=4a3f3bae&scoped=true&"
import script from "./UserBlacklistList.vue?vue&type=script&lang=js&"
export * from "./UserBlacklistList.vue?vue&type=script&lang=js&"
import style0 from "./UserBlacklistList.vue?vue&type=style&index=0&id=4a3f3bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3f3bae",
  null
  
)

export default component.exports